module.exports = __webpack_public_path__ + "img/main.edd4bf50.png";